import { Outlet } from "react-router-dom";
import { Stack, styled } from "@mui/material";

export const CompanyLayout = () => {
  return (
    <CompanyLayoutWrapper>
      <Outlet />
    </CompanyLayoutWrapper>
  );
};

const CompanyLayoutWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
`;
